import Text from '@deprecated-ui/common/Text';
import SpecialMonitoringInformation from 'features/securities/static/information/specialMonitoring';
import {
  SpecialMonitoringButton,
  SpecialMonitoringModalContainer,
} from './styled';

interface Props {
  visible: boolean;
  closeModal: () => void;
}

const SpecialMonitoringModal = ({ visible, closeModal }: Props) => (
  <SpecialMonitoringModalContainer
    visible={visible}
    centered
    onCancel={closeModal}
  >
    <Text size="18px" align="center" family="bold" padding="40px 30px 16px">
      Informasi Pemantauan Khusus
    </Text>

    <div className="special-monitoring__content">
      <SpecialMonitoringInformation />
    </div>

    <SpecialMonitoringButton
      onClick={closeModal}
      type="primary"
      radius="4px"
      block
      height="40px"
    >
      <Text align="inherit" color="inherit" family="bold" size="16px">
        Oke
      </Text>
    </SpecialMonitoringButton>
  </SpecialMonitoringModalContainer>
);

export default SpecialMonitoringModal;
